import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useAuth } from '@/hooks/useAuth';
import { QUERY } from '@/constants/common';
import { useUrlAndHashFromPath } from '@/hooks/useUrlAndHashFromPath';

export function useLoginUser(accessTokenProp?: string) {
  const { replace, query } = useRouter();
  const { loginUser } = useAuth();
  const accessToken =
    accessTokenProp || (query[QUERY.access_token] as string | undefined);
  const [isLoginInProgress, setLoginInProgress] = useState(!!accessToken);
  const { trimmedUrl } = useUrlAndHashFromPath([QUERY.access_token]);

  useEffect(() => {
    if (accessToken) {
      setLoginInProgress(true);
      (async () => {
        await loginUser({ variables: { accessToken } });
        replace(trimmedUrl, undefined, { scroll: false, shallow: true });
        setLoginInProgress(false);
      })();
    }
  }, [accessToken]);

  return isLoginInProgress;
}
